<template>
<nav v-if="canLoad" class="menu" :class="{active}" @click.self="active = false">
  <router-link
    to="/"
    class="menu_logo"
    @click.passive="active = false">
    <img src="../assets/logo.png"/></router-link>
  <a href="#" id="" @click.prevent="toogleMenu" class="menu_mobileToggle">
    <img src="../assets/images/hamburguer.svg" alt="" v-show="!active">
    <img src="../assets/images/close.svg" alt="" v-show="active">
  </a>
  <ul class="menu_links" @click.passive="active = false">
    <li><router-link to="/futebol/">Futebol</router-link></li>
    <li><router-link to="/modalidades/">Modalidades</router-link></li>
    <li><router-link to="/casino/">Casino</router-link></li>
    <li><router-link to="/patrocinios/">Patrocínios</router-link></li>
    <li><router-link to="/herois/">Heróis Betano</router-link></li>
    <li><router-link to="/betano-mag/">Betanomag</router-link></li>
    <li><router-link to="/tutorial-betano-tudo-sobre-apostas-e-casino-de-a-a-z/">Tutorial</router-link></li>
  </ul>
</nav>
</template>

<script>
export default {
  name: 'MainMenu',
  props: {
    canLoad: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      active: false,
    }
  },
  methods: {
    toogleMenu() {
      this.active = !this.active
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/queries";
@import "@/assets/scss/fonts";

@keyframes slideIn {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

.menu {
    font-family: $ff-headings;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: min-content 1fr;
  overflow: hidden;
  transition: .2s ease-out background-color;
  background-image: linear-gradient(
    180deg,
    rgba(0,0,0,1) 0%,
    rgba(0,0,0,.85) calc(var(--menu-padding) * 1.5),
    rgba(0,0,0,0) calc(var(--menu-padding) * 4),
    );

  @include media(lg, true) {
    &:not(.active) {
      pointer-events: none;
    }
  }

  a {
    pointer-events: all;
  }

  @include media(lg) {
    height: fit-content;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3.75rem 5.75rem;

    background-image: linear-gradient(
      180deg,
      rgba(0,0,0,1) 0%,
      rgba(0,0,0,.85) 40%,
      rgba(0,0,0,0) 100%
      );

    animation: slideIn 1s;
    animation-delay: 1s;
    animation-fill-mode: both;
  }

  &.active {
    background-color: rgba(16, 23, 32, 0.50);
    .menu_links {
      transform: translateX(0);
    }
  }

  &_links {
    grid-column: 1/-1;
    grid-row: 1/-1;
    width: 66.666%;
    margin: 0 0 0 auto;
    display: flex;
    justify-content: space-between;
    text-align: right;
    padding: 0;
    list-style-type: none;
    font-size: 1rem;

    @include media(lg, true) {
        font-weight: 900;
        font-style: italic;
        backdrop-filter: blur(10px);
        transform: translateX(100%);
        transition: .2s ease-out transform;
        background: rgba(16, 23, 32, 0.50);
        flex-direction: column;
        padding: calc(var(--menu-padding) * 4) var(--menu-padding) var(--menu-padding);
    }

    @include media(lg) {
        font-size: .8rem;
        margin: auto 0;
        width: 100%;
        justify-content: space-around;
    }

    @include media(xl) {
        font-size: 1rem;
    }
  }
  &_logo {
    grid-row: 1;
    grid-column: 1;
        max-width: 150px;
        img {
            width: 100%;
        }
    @include media(lg, true) {
      margin: var(--menu-padding) 0 var(--menu-padding) var(--menu-padding);
    }
  }
  &_mobileToggle {
    grid-column: 2;
    grid-row: 1;
    margin: auto var(--menu-padding) auto auto;
    z-index: 10;
    @include media(lg) {
      display: none;
    }
  }
}

nav {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;

  width: 100%;
  height: 100%;


  a {
    font-weight: bold;
    color: white;
    text-decoration: none;
    text-transform: uppercase;
    &.router-link-exact-active {
    }
  }
}
</style>
